import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {useTranslate} from "@tolgee/react";

type InfoIconWithToolTipProps = {
    text: string;
    placement?: "top" | "bottom" | "left" | "right";
    showTokens?: boolean;
    availableTokens?: number;
    usedTokens?: number;
    advancedDataButton?: boolean;
};

export const InfoIconWithToolTip: React.FC<InfoIconWithToolTipProps> = ({
                                                                            text,
                                                                            placement = "top",
                                showTokens = false,
    availableTokens = 0,
    usedTokens = 0,
                                                                            advancedDataButton = false
                                                                        }) => {

    const {t} = useTranslate();

    return (
        <OverlayTrigger
            placement={placement}
            overlay={
                <Tooltip>
                    <div className="text-gray-400 fw-bold d-block fs-7 text-start">
                        {text}
                    </div>
                    {showTokens ? (
                        <div className={"d-flex flex-column justify-content-end mt-2"}>
                            <div className="text-gray-400 fw-bold d-block fs-7 text-end w-100">{t('lomavis.branding.mainActions.noTokensTooltip.tokenInfo')}:</div>
                            <div className="text-gray-400 fw-bold d-block fs-7 text-end w-100">{usedTokens}/{availableTokens}</div>
                        </div>
                    ): ''}
                </Tooltip>
            }
        >
            <i className={`fa-duotone fa-circle-info cursor-pointer ${advancedDataButton ? 'text-white':''}`} />
        </OverlayTrigger>
    );
};